import { SECTION_INDEXES } from "./SectionIndexes";

export const FormSections = [
    {
        englishName: 'Title Page',
        frenchName: 'Page titre',
        index: SECTION_INDEXES.TITLE_PAGE,
        children: []
    },
    {
        englishName: 'Product Details',
        frenchName: 'Détails du produit',
        index: SECTION_INDEXES.PRODUCT_DETAILS,
        children: [
            {
                englishName: 'Company Details',
                frenchName: "Détails de l'entreprise",
                index: SECTION_INDEXES.COMPANY_DETAILS,
                children: []
            },
            {
                englishName: 'Products',
                frenchName: 'Produits',
                index: SECTION_INDEXES.PRODUCTS,
                children: []
            }
        ]
    },
    {
        englishName: 'Recent Major Label Changes',
        frenchName: 'Modifications importantes apportées récemment à la monographie',
        index: SECTION_INDEXES.RECENT_MAJOR_LABEL_CHANGES,
        children: []
    },
    {
        englishName: 'Part I: Health Professional Information',
        frenchName: 'Partie I : Renseignements pour le professionnel de la santé',
        index: SECTION_INDEXES.PART_ONE,
        children: [
            {
                englishName: '1 Indications',
                frenchName: '1 Indications',
                index: SECTION_INDEXES.INDICATIONS,
                children: [
                    {
                        englishName: '1.1 Pediatrics',
                        frenchName: '1.1 Pédiatrie',
                        index: SECTION_INDEXES.PEDIATRICS,
                        children: []
                    },
                    {
                        englishName: '1.2 Geriatrics',
                        frenchName: '1.2 Gériatrie',
                        index: SECTION_INDEXES.GERIATRICS,
                        children: []
                    }
                ]
            },
            {
                englishName: '2 Contraindications',
                frenchName: '2 Contre-indications',
                index: SECTION_INDEXES.CONTRAINDICATIONS,
                children: []
            },
            {
                englishName: '3 Serious Warnings And Precautions Box',
                frenchName: '3 Encadré mises en garde et précautions importantes',
                index: SECTION_INDEXES.SERIOUS_WARNINGS_AND_PRECAUTIONS_BOX,
                children: []
            },
            {
                englishName: '4 Dosage And Administration',
                frenchName: '4 Posologie Et Administration',
                index: SECTION_INDEXES.DOSAGE_AND_ADMINISTRATION,
                children: [
                    {
                        englishName: '4.1 Dosing Considerations',
                        frenchName: '4.1 Considérations posologiques',
                        index: SECTION_INDEXES.DOSING_CONSIDERATIONS,
                        children: []
                    },
                    {
                        englishName: '4.2 Recommended Dose And Dosage Adjustments',
                        frenchName: '4.2 Posologie recommandée et ajustement posologique',
                        index: SECTION_INDEXES.RECOMMENDED_DOSE_AND_DOSAGE_ADJUSTMENTS,
                        children: []
                    },
                    {
                        englishName: '4.3 Reconstitution',
                        frenchName: '4.3 Reconstitution',
                        index: SECTION_INDEXES.RECONSTITUITION,
                        children: []
                    },
                    {
                        englishName: '4.4 Administration',
                        frenchName: '4.4 Administration',
                        index: SECTION_INDEXES.ADMINISTRATION,
                        children: []
                    },
                    {
                        englishName: '4.5 Missed Dose',
                        frenchName: '4.5 Dose oubliée',
                        index: SECTION_INDEXES.MISSED_DOSE,
                        children: []
                    },
                    {
                        englishName: '4.6 Image Aquisition And Interpretation',
                        frenchName: "4.6 Acquisition et interprétation d'image",
                        index: SECTION_INDEXES.IMAGE_ACQUISITION_AND_INTERPRETATION,
                        children: []
                    },
                    {
                        englishName: '4.7 Instructions For Preparation And Use',
                        frenchName: "4.7 Instructions pour la préparation et l'utilisation",
                        index: SECTION_INDEXES.INSTRUCTIONS_FOR_PREPARATION_AND_USE,
                        children: []
                    },
                    {
                        englishName: '4.8 Radiation Dosimetry',
                        frenchName: '4.8 Dosimétrie des rayonnements',
                        index: SECTION_INDEXES.RADIATION_DOSIMETRY,
                        children: []
                    }
                ]
            },
            {
                englishName: '5 Overdose',
                frenchName: '5 Surdose',
                index: SECTION_INDEXES.OVERDOSAGE,
                children: []
            },
            {
                englishName: '6 Dosage Forms, Strengths, Composition, And Packaging',
                frenchName: '6 Formes pharmaceutiques, teneurs, composition et conditionnement',
                index: SECTION_INDEXES.DOSAGE_FORMS_STRENGTHS_COMPOSITION_AND_PACKAGING,
                children: [
                    {
                        englishName: '6.1 Physical Characteristics',
                        frenchName: '6.1 Caractéristiques physiques',
                        index: SECTION_INDEXES.PHYSICAL_CHARACTERISTICS,
                        children: []
                    },
                    {
                        englishName: '6.2 External Radiation',
                        frenchName: '6.2 Irradiation externe',
                        index: SECTION_INDEXES.EXTERNAL_RADIATION,
                        children: []
                    }
                ]
            },
            {
                englishName: '7 Warnings And Precautions',
                frenchName: '7 Mises en garde et précautions',
                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS,
                children: [
                    {
                        englishName: '7.0 Other Warnings and Precautions',
                        frenchName: '7.0 Autres mises en garde et précautions',
                        index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_GENERAL_PARENT,
                        children: [
                            {
                                englishName: '7.0.1 General',
                                frenchName: '7.0.1 Généralités',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_GENERAL,
                                children: []
                            },
                            {
                                englishName: '7.0.2 Carcinogenesis and Genotoxicity',
                                frenchName: '7.0.2 Cancérogenèse et génotoxicité',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_CARCINOGENESIS,
                                children: []
                            },
                            {
                                englishName: '7.0.3 Cardiovascular',
                                frenchName: '7.0.3 Appareil cardiovasculaire',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_CARDIOVASCULAR,
                                children: []
                            },
                            {
                                englishName: '7.0.4 Contamination',
                                frenchName: '7.0.4 Contamination',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_CONTAMINATION,
                                children: []
                            },
                            {
                                englishName: '7.0.5 Dependence, Tolerance and/or Abuse Liability',
                                frenchName: '7.0.5 Dépendance, tolérance et risque d\'abus',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_DEPENDENCE,
                                children: []
                            },
                            {
                                englishName: '7.0.6 Driving and Operating Machinery',
                                frenchName: '7.0.6 Conduite et utilisation de machines',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_DRIVING,
                                children: []
                            },
                            {
                                englishName: '7.0.7 Ear/Nose/Throat',
                                frenchName: '7.0.7 Oreille/nez/gorge',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_EAR_NOSE_THROAT,
                                children: []
                            },
                            {
                                englishName: '7.0.8 Endocrine and Metabolism',
                                frenchName: '7.0.8 Système endocrinien et métabolisme',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_ENDOCRINE,
                                children: []
                            },
                            {
                                englishName: '7.0.9 Gastrointestinal',
                                frenchName: '7.0.9 Appareil digestif',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_GASTROINTESTINAL,
                                children: []
                            },
                            {
                                englishName: '7.0.10 Genitourinary',
                                frenchName: '7.0.10 Appareil génito-urinaire',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_GENITOURINARY,
                                children: []
                            },
                            {
                                englishName: '7.0.11 Hematologic',
                                frenchName: '7.0.11 Système sanguin et lymphatique',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_HEMATOLOGIC,
                                children: []
                            },
                            {
                                englishName: '7.0.12 Hepatic/Biliary/Pancreatic',
                                frenchName: '7.0.12 Fonctions hépatique, biliaire et pancréatique',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_HEPATIC,
                                children: []
                            },
                            {
                                englishName: '7.0.13 Immune',
                                frenchName: '7.0.13 Système immunitaire',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_IMMUNE,
                                children: []
                            },
                            {
                                englishName: '7.0.14 Monitoring and Laboratory Tests',
                                frenchName: '7.0.14 Surveillance et examens de laboratoire',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_MONITORING,
                                children: []
                            },
                            {
                                englishName: '7.0.15 Musculoskeletal',
                                frenchName: '7.0.15 Appareil musculosquelettique',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_MUSCULOSKELETAL,
                                children: []
                            },
                            {
                                englishName: '7.0.16 Neurologic',
                                frenchName: '7.0.16 Système nerveux',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_NEUROLOGIC,
                                children: []
                            },
                            {
                                englishName: '7.0.17 Ophthalmologic',
                                frenchName: '7.0.17 Fonction visuelle',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_OPHTHALMOLOGIC,
                                children: []
                            },
                            {
                                englishName: '7.0.18 Perioperative Considerations',
                                frenchName: '7.0.18 Considérations périopératoires',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_PERIOPERATIVE,
                                children: []
                            },
                            {
                                englishName: '7.0.19 Psychiatric',
                                frenchName: '7.0.19 Fonction psychiatrique',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_PSYCHIATRIC,
                                children: []
                            },
                            {
                                englishName: '7.0.20 Renal',
                                frenchName: '7.0.20 Fonction rénale',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_RENAL,
                                children: []
                            },
                            {
                                englishName: '7.0.21 Reproductive Health',
                                frenchName: '7.0.21 Santé reproductive',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_REPRODUCTIVE,
                                children: []
                            },
                            {
                                englishName: '7.0.22 Respiratory',
                                frenchName: '7.0.22 Appareil respiratoire',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_RESPIRATORY,
                                children: []
                            },
                            {
                                englishName: '7.0.23 Sensitivity/Resistance',
                                frenchName: '7.0.23 Sensibilité et résistance',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_SENSITIVITY,
                                children: []
                            },
                            {
                                englishName: '7.0.24 Skin',
                                frenchName: '7.0.24 Appareil cutané',
                                index: SECTION_INDEXES.WARNINGS_AND_PRECAUTIONS_SKIN,
                                children: []
                            }
                        ]
                    },
                    {
                        englishName: '7.1 Special Populations',
                        frenchName: '7.1 Populations particulières',
                        index: SECTION_INDEXES.SPECIAL_POPULATIONS,
                        children: [
                            {
                                englishName: '7.1.1 Pregnant Women',
                                frenchName: '7.1.1 Femmes enceintes',
                                index: SECTION_INDEXES.PREGNANT_WOMEN,
                                children: []
                            },
                            {
                                englishName: '7.1.2 Breast-Feeding',
                                frenchName: '7.1.2 Femmes qui allaitent',
                                index: SECTION_INDEXES.BREAST_FEEDING,
                                children: []
                            },
                            {
                                englishName: '7.1.3 Pediatrics',
                                frenchName: '7.1.3 Enfants et adolescents',
                                index: SECTION_INDEXES.PEDIATRICS_WARNINGS_AND_PRECAUTIONS,
                                children: []
                            },
                            {
                                englishName: '7.1.4 Geriatrics',
                                frenchName: '7.1.4 Personnes âgées',
                                index: SECTION_INDEXES.GERIATRICS_WARNINGS_AND_PRECAUTIONS,
                                children: []
                            }
                        ]
                    }
                ]
            },
            {
                englishName: '8 Adverse Reactions',
                frenchName: '8 Effets indésirables',
                index: SECTION_INDEXES.ADVERSE_REACTIONS,
                children: [
                    {
                        englishName: '8.1 Adverse Reaction Overview',
                        frenchName: '8.1 Aperçu des effets indésirables',
                        index: SECTION_INDEXES.ADVERSE_REACTIONS_OVERVIEW,
                        children: []
                    },
                    {
                        englishName: '8.2 Clinical Trial Adverse Reactions',
                        frenchName: '8.2 Effets indésirables observés au cours des études cliniques',
                        index: SECTION_INDEXES.CLINICAL_TRIAL_ADVERSE_REACTIONS,
                        children: [
                            {
                                englishName: '8.2.1 Clinical Trial Adverse Reactions (Pediatrics)',
                                frenchName: '8.2.1 Effets indésirables observés au cours des études cliniques – Enfants et adolescents',
                                index: SECTION_INDEXES.CLINICAL_TRIAL_ADVERSE_REACTIONS_PEDIATRICS,
                                children: []
                            }
                        ]
                    },
                    {
                        englishName: '8.3 Less Common Clinical Trial Adverse Reactions',
                        frenchName: '8.3 Effets indésirables peu fréquents observés au cours des études cliniques',
                        index: SECTION_INDEXES.LESS_COMMON_CLINICAL_TRIAL_ADVERSE_REACTIONS,
                        children: [
                            {
                                englishName: '8.3.1 Less Common Clinical Trial Adverse Reactions (Pediatrics)',
                                frenchName: '8.3.1 Effets indésirables peu fréquents observés au cours des études cliniques – Enfants et adolescents',
                                index: SECTION_INDEXES.LESS_COMMON_CLINICAL_TRIAL_ADVERSE_REACTIONS_PEDIATRICS,
                                children: []
                            }
                        ]
                    },
                    {
                        englishName: '8.4 Abnormal Laboratory Findings: Hematologic, Clinical Chemistry And Other Quantitative Data',
                        frenchName: '8.4 Résultats anormaux aux examens de laboratoire : données hématologiques, données biochimiques et autres données quantitatives',
                        index: SECTION_INDEXES.ABNORMAL_LABORATORY_FINDINGS_HEMATOLOGIC,
                        children: []
                    },
                    {
                        englishName: '8.5 Post-Market Adverse Reactions',
                        frenchName: '8.5 Effets indésirables observés après la commercialisation',
                        index: SECTION_INDEXES.POST_MARKET_ADVERSE_REACTIONS,
                        children: []
                    }
                ]
            },
            {
                englishName: '9 Drug Interactions',
                frenchName: '9 Interactions médicamenteuses',
                index: SECTION_INDEXES.DRUG_INTERACTIONS,
                children: [
                    {
                        englishName: '9.1 Serious Drug Interactions',
                        frenchName: '9.1 Interactions médicamenteuses graves',
                        index: SECTION_INDEXES.SERIOUS_DRUG_INTERACTIONS,
                        children: []
                    },
                    {
                        englishName: '9.2 Drug Interactions Overview',
                        frenchName: '9.2 Aperçu des interactions médicamenteuses',
                        index: SECTION_INDEXES.DRUG_INTERACTIONS_OVERVIEW,
                        children: []
                    },
                    {
                        englishName: '9.3 Drug-Behavioural Interactions',
                        frenchName: '9.3 Interactions médicament-comportement',
                        index: SECTION_INDEXES.DRUG_BEHAVIOURAL_INTERACTIONS,
                        children: []
                    },
                    {
                        englishName: '9.4 Drug-Drug Interactions',
                        frenchName: '9.4 Interactions médicament-médicament',
                        index: SECTION_INDEXES.DRUG_DRUG_INTERACTIONS,
                        children: []
                    },
                    {
                        englishName: '9.5 Drug-Food Interactions',
                        frenchName: '9.5 Interactions médicament-aliment',
                        index: SECTION_INDEXES.DRUG_FOOD_INTERACTIONS,
                        children: []
                    },
                    {
                        englishName: '9.6 Drug-Herb Interactions',
                        frenchName: '9.6 Interactions médicament-plante médicinale',
                        index: SECTION_INDEXES.DRUG_HERB_INTERACTIONS,
                        children: []
                    },
                    {
                        englishName: '9.7 Drug-Laboratory Test Interactions',
                        frenchName: '9.7 Interactions médicament-examens de laboratoire',
                        index: SECTION_INDEXES.DRUG_LABORATORY_TEST_INTERACTIONS,
                        children: []
                    }
                ]
            },
            {
                englishName: '10 Clinical Pharmacology',
                frenchName: '10 Pharmacologie clinique',
                index: SECTION_INDEXES.ACTION_AND_CLINICAL_PHARMACOLOGY,
                children: [
                    {
                        englishName: '10.1 Mechanism Of Action',
                        frenchName: "10.1 Mode d'action",
                        index: SECTION_INDEXES.MECHANISM_OF_ACTION,
                        children: []
                    },
                    {
                        englishName: '10.2 Pharmacodynamics',
                        frenchName: '10.2 Pharmacodynamie',
                        index: SECTION_INDEXES.PHARMACODYNAMICS,
                        children: []
                    },
                    {
                        englishName: '10.3 Pharmacokinetics',
                        frenchName: '10.3 Pharmacocinétique',
                        index: SECTION_INDEXES.PHARMACOKINETICS,
                        children: []
                    },
                    {
                        englishName: '10.4 Immunogenicity',
                        frenchName: '10.4 Immunogénicité',
                        index: SECTION_INDEXES.IMMUNOGENICITY,
                        children: []
                    }
                ]
            },
            {
                englishName: '11 Storage, Stability, And Disposal',
                frenchName: '11 Conservation, stabilité et mise au rebut',
                index: SECTION_INDEXES.STORAGE_STABILITY_AND_DISPOSAL,
                children: []
            },
            {
                englishName: '12 Special Handling Instructions',
                frenchName: '12 Particularités de manipulation du produit',
                index: SECTION_INDEXES.SPECIAL_HANDLING_INSTRUCTIONS,
                children: []
            }
        ]
    },
    {
        englishName: 'Part II: Scientific Information',
        frenchName: 'Partie II: Renseignements Scientifiques',
        index: SECTION_INDEXES.PART_TWO,
        children: [
            {
                englishName: '13 Pharmaceutical Information',
                frenchName: '13 Information pharmaceutiques',
                index: SECTION_INDEXES.PHARMACEUTICAL_INFORMATION,
                children: []
            },
            {
                englishName: '14 Clinical Trials',
                frenchName: '14 Études cliniques',
                index: SECTION_INDEXES.CLINICAL_TRIALS,
                children: [
                    {
                        englishName: '14.1 Clinical Trials By Indication',
                        frenchName: '14.1 Études cliniques par indication',
                        index: SECTION_INDEXES.CLINICAL_TRIALS_BY_INDICATIONS,
                        children: []
                    },
                    {
                        englishName: '14.2 Comparative Bioavailabilty Studies',
                        frenchName: '14.2 Études de biodisponibilité comparatives',
                        index: SECTION_INDEXES.COMPARATIVE_BIOAVAILABILTY_STUDIES,
                        children: []
                    },
                ]
            },
            {
                englishName: '15 Microbiology',
                frenchName: '15 Microbiologie',
                index: SECTION_INDEXES.MICROBIOLOGY,
                children: []
            },
            {
                englishName: '16 Non-Clinical Toxicology',
                frenchName: '16 Toxicologie non clinique',
                index: SECTION_INDEXES.NON_CLINICAL_TOXICOLOGY,
                children: [
                    {
                        englishName: '16.1 Comparative Non-Clinical Pharmacology And Toxicology',
                        frenchName: '16.1 Pharmacologie et toxicologie non cliniques comparatives',
                        index: SECTION_INDEXES.COMPARATIVE_NON_CLINICAL_PHARMACOLOGY_AND_TOXICOLOGY,
                        children: [
                            {
                                englishName: '16.1.1 Comparative Non-Clinical Pharmacodynamics',
                                frenchName: '16.1.1 Pharmacodynamie non clinique comparative',
                                index: SECTION_INDEXES.COMPARATIVE_NON_CLINICAL_PHARMACODYNAMICS,
                                children: []
                            },
                            {
                                englishName: '16.1.2 Comparative Toxicology',
                                frenchName: '16.1.2 Toxicologie comparative',
                                index: SECTION_INDEXES.COMPARATIVE_TOXICOLOGY,
                                children: []
                            }
                        ]
                    }
                ]
            },
            {
                englishName: '17 Supporting Product Monographs',
                frenchName: '17 Monographies de référence',
                index: SECTION_INDEXES.SUPPORTING_PRODUCT_MONOGRAPHS,
                children: []
            }
        ]
    },
    {
        englishName: 'Patient Medical Information',
        frenchName: 'Renseignements destinés aux patient·e·s',
        index: SECTION_INDEXES.PART_THREE,
        children: [
            {
                englishName: 'Brand Name',
                frenchName: 'Marque nominative',
                index: SECTION_INDEXES.BRAND_NAME,
                children: []
            },
            {
                englishName: 'Proper Name',
                frenchName: 'Nom propre',
                index: SECTION_INDEXES.PROPER_NAME,
                children: []
            },
            {
                englishName: 'Read This For Safe And Effective Use Of Your Medicine',
                frenchName: 'Lisez ce document pour une utilisation sécuritaire et efficace de votre médicament',
                index: SECTION_INDEXES.READ_THIS_FOR_SAFE_AND_EFFECTIVE_USE_OF_YOUR_MEDICINE,
                children: []
            },
            {
                englishName: 'What Is [Brand Name] Used For?',
                frenchName: 'Pourquoi utilise-t-on [Nom Commercial]?',
                index: SECTION_INDEXES.WHAT_IS_BRAND_NAME_USED_FOR,
                children: []
            },
            {
                englishName: 'How Does [Brand Name] Work?',
                frenchName: "Comment [Nom Commercial] agit-il?",
                index: SECTION_INDEXES.HOW_DOES_BRAND_NAME_WORK,
                children: []
            },
            {
                englishName: 'What Are The Ingredients In [Brand Name]?',
                frenchName: 'Quels sont les ingrédients de [Nom Commercial]?',
                index: SECTION_INDEXES.WHAT_ARE_THE_INGREDIENTS_IN_BRAND_NAME,
                children: []
            },
            {
                englishName: '[Brand Name] Comes In The Following Dosage Forms:',
                frenchName: '[Nom Commercial] se présente sous la ou les formes pharmaceutiques suivantes :',
                index: SECTION_INDEXES.BRAND_NAME_DOSAGE_FORMS,
                children: []
            },
            {
                englishName: 'Do Not Use [Brand Name] If:',
                frenchName: "N'utilisez pas [Nom Commercial] dans les cas suivants :",
                index: SECTION_INDEXES.DO_NOT_USE_BRAND_NAME_IF,
                children: []
            },
            {
                englishName: 'To Help Avoid Side Effects And Ensure Proper Use, Talk To Your Healthcare Professional Before You Take [Brand Name]. Talk About Any Health Conditions Or Problems You May Have, Including If You:',
                frenchName: "Consultez votre professionnel de la santé avant d'utiliser [Nom Commercial], afin d'assurer l'utilisation adéquate du médicament et d'aider à éviter les effets secondaires. Informez votre professionnel de la santé de votre état actuel et de vos problèmes de santé, notamment :",
                index: SECTION_INDEXES.HEALTH_CONDITIONS_OR_PROBLEMS,
                children: []
            },
            {
                englishName: 'Other Warnings You Should Know About:',
                frenchName: 'Autres mises en garde',
                index: SECTION_INDEXES.OTHER_WARNINGS_YOU_SHOULD_KNOW_ABOUT,
                children: []
            },
            {
                englishName: 'The Following May Interact With [Brand Name]:',
                frenchName: 'Les produits suivants pourraient interagir avec [Nom Commercial] :',
                index: SECTION_INDEXES.THE_FOLLOWING_MAY_INTERACT_WITH_BRAND_NAME,
                children: []
            },
            {
                englishName: 'How To Take [Brand Name]:',
                frenchName: 'Comment utiliser [Nom Commercial]?',
                index: SECTION_INDEXES.HOW_TO_TAKE_BRAND_NAME,
                children: []
            },
            {
                englishName: 'Usual Dose:',
                frenchName: 'Dose habituelle :',
                index: SECTION_INDEXES.USUAL_DOSE,
                children: []
            },
            {
                englishName: 'Overdose:',
                frenchName: 'Surdose :',
                index: SECTION_INDEXES.OVER_DOSE,
                children: []
            },
            {
                englishName: 'Missed Dose:',
                frenchName: 'Dose oubliée :',
                index: SECTION_INDEXES.MISSED_DOSE_PMI,
                children: []
            },
            {
                englishName: 'What Are Possible Side Effects From Using [Brand Name]?',
                frenchName: 'Quels sont les effets secondaires qui pourraient être associés à [Nom Commercial]?',
                index: SECTION_INDEXES.POSSIBLE_SIDE_EFFECTS,
                children: []
            },
            {
                englishName: 'Storage:',
                frenchName: 'Conservation',
                index: SECTION_INDEXES.STORAGE,
                children: []
            },
            {
                englishName: 'If You Want More Information About [Brand Name]:',
                frenchName: 'Pour en savoir plus sur [Nom Commercial] :',
                index: SECTION_INDEXES.MORE_INFORMATION,
                children: []
            }
        ]
    },
    {
        englishName: 'Unassigned Sections',
        frenchName: 'Sections non attribuées',
        index: SECTION_INDEXES.UNASSIGNED_SECTIONS,
        children: []
    },
    {
        englishName: 'Biosimilar Biologic Drug',
        frenchName: 'Médicaments biologiques biosimilaires',
        index: SECTION_INDEXES.BIOSIMILAR_BIOLOGIC_DRUG,
        children: []
    },
    {
        englishName: 'Footnotes',
        frenchName: 'Notes de bas de page',
        index: SECTION_INDEXES.FOOTNOTES,
        children: []
    }
]

const getNumericPrefixMatch = (name) => {
    const numericPartMatch = name.match(/^\d+(\.\d+)*/);
    return numericPartMatch ? numericPartMatch[0] : null;
};

const normalizeSectionName = (name) => {
    return name.toLowerCase().replace(/[^\w\d\s]/g, '').replace(/ +/g, '-');
};

export const getSectionUrlName = (sectionName) => {
    const numericPart = getNumericPrefixMatch(sectionName);
    return numericPart ? numericPart : normalizeSectionName(sectionName);
};